import { takeEvery, call, put, all } from 'redux-saga/effects';
import * as pluginActionCreators from 'pluginServices/actionCreators';
import * as pluginConstants from 'pluginServices/constants';
import { replace, push } from 'connected-react-router';
import env from 'constants/env';
import * as connMgrActions from 'containers/ConnectionManager/actions';
import { GET_PLUGIN_SCHEMA } from 'data/Plugin/constants';

function* fetchDocumentFromNetwork(loadCoursewareItemAction) {
  // TODO use RTM to fetch the document.
  // TODO don't fetch twice for the same id.
  const { id: docId } = loadCoursewareItemAction;
  try {
    const response = yield call(
      fetch,
      `${env.PLUGIN_SERVER_URL}/coursewares/${docId}.json`
    );
    if (response.ok) {
      const doc = yield call(response.json.bind(response));
      yield put(pluginActionCreators.setCoursewareItem(docId, doc));
    } else {
      // Document not found, redirect to home
      yield put(replace('/'));
    }
  } catch (e) {
    // Don't retry, do nothing. Because we'll switch to RTM/sync layer in the future.
  }
}

function* navigateBuilderToCourseware(coursewareAction) {
  try {
    const response = yield call(
      fetch,
      `${env.PLUGIN_SERVER_URL}/plugins/${coursewareAction.id}/manifest.json`
    );

    if (response.ok) {
      const manifest = yield call(response.json.bind(response));
      switch (manifest.type) {
        case 'course':
          yield put(push(`/course/${coursewareAction.id}`));
          return;
        case 'lesson':
          yield put(push(`/lesson/${coursewareAction.id}`));
          return;
        default:
          break;
      }
    }
  } catch (e) {
    // Don't retry, do nothing. Because we'll switch to RTM/sync layer in the future.
  }

  yield put(push('/'));
}

function* fetchPluginAndReturnSchema(getSchemaAction) {
  const { pluginId, version, schemaCallback } = getSchemaAction;
  yield put(connMgrActions.commandAuthorPluginGet(pluginId, version, (manifest, schema) => {
    schemaCallback(schema);
  }));
}

export default function* pluginLoader() {
  yield all([
    takeEvery(pluginConstants.LOAD_COURSEWARE_ITEM, fetchDocumentFromNetwork),
    takeEvery(pluginConstants.OPEN_COURSEWARE_ITEM, navigateBuilderToCourseware),
    takeEvery(GET_PLUGIN_SCHEMA, fetchPluginAndReturnSchema),
  ]);
}
